// const value = 1234.5678
// const formattedValue = value.toLocaleString('en-US', { maximumFractionDigits: 2 })
// console.log(formattedValue) // 输出 "1,234.57"

// const value = 1234.5
// const formattedValue = value.toLocaleString('en-US', { minimumFractionDigits: 2 })
// console.log(formattedValue) // 输出 "1,234.50"

// const value = 1234.5
// const formattedValue = value.toLocaleString('en-US', {
//   minimumFractionDigits: 2,
//   maximumFractionDigits: 2
// })
// console.log(formattedValue) // 输出 "1,234.50"
/// 针对千位分割法处理（如果需要针对两位小数那么可以添加上面注释的方法）
export default function formatThousandSeparator(numberValue: string | undefined) {
  const value = Number(numberValue)
  if (isNaN(value)) {
    return ''
  }
  return value.toLocaleString('en-US', { maximumFractionDigits: 2 })
}

/// 转换
export function formatAmount(numberValue: string | undefined, fractionDigits = 3) {
  if (!numberValue) return '--'
  const value = Number(numberValue)
  if (isNaN(value)) {
    return numberValue
  }
  /// 转换为浮点数并格式化为三位小数点
  const amount = parseFloat(numberValue).toFixed(fractionDigits)
  const floatValue = parseFloat(amount)
  const intValue = parseInt(amount, 10)
  // 如果是整型，返回整型显示
  if (floatValue === intValue) {
    return intValue === 0 ? '--' : intValue
  }
  return floatValue === 0 ? '--' : floatValue// 将字符串转换回浮点数，自动去掉末尾的0
}

export function removeTrailingZeros(numberString: string): string {
  const trimmedString = numberString.trim() // 去除首尾空格
  const decimalIndex = trimmedString.indexOf('.')

  if (decimalIndex !== -1) {
    let endIndex = trimmedString.length - 1

    while (trimmedString[endIndex] === '0') {
      endIndex--
    }

    if (trimmedString[endIndex] === '.') {
      endIndex-- // 如果小数点后面全是零，也去掉小数点
    }

    return trimmedString.slice(0, endIndex + 1)
  }

  return trimmedString
}
